import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';

const getCourseImage = type => {
  switch (type) {
    case 1:
      return 'img/courses/csharp-profile.svg';
    case 2:
      return 'img/courses/javascript-profile.svg';
    case 3:
      return 'img/courses/typescript-profile.svg';
    case 4:
      return 'img/courses/nodejs-profile.svg';
    default:
      return '';
    // TODO default image
  }
};

const courseTypeToString = type => {
  switch (type) {
    case 1:
      return 'C#';
    case 2:
      return 'Javascript';
    case 3:
      return 'Typescript';
    case 4:
      return 'Nodejs';
    default:
      return 'Unknown course type';
  }
};

const userLevelToString = level => {
  switch (level) {
    case 1:
      return 'BEGINNER';
    case 2:
      return 'INTERMEDIATE';
    case 3:
      return 'ADVANCED';
    default:
      return 'ADVANCED';
  }
};

const ProfileCoursesMobile = props => {
  return (
    <div>
      {props.courses.length === 0 && (
        <div className="m-profile-tab-content-message">You do not have any courses yet</div>
      )}
      {props.courses.map(course => {
        const percent = course.webinarsCount > 0 ? Math.ceil((course.webinarsPassed / course.webinarsCount) * 100) : 0;
        return (
          <div key={course.id} className="m-profile-course">
            <div className="is-flex align-items-center justify-content-between">
              <div className="is-flex align-items-center">
                <img src={getCourseImage(course.type)} width={40} />
                <div className="ml-10px">
                  <p className="m-profile-course-title">{courseTypeToString(course.type)}</p>
                  <p className="m-profile-course-title m-profile-course-name">{course.name}</p>
                </div>
              </div>
              <CircularProgressbar
                value={percent}
                text={`${percent}%`}
                styles={{
                  root: {
                    width: '32px', // TODO add class name
                  },
                  path: {
                    stroke: '#6819B8',
                  },
                  text: {
                    // Text color
                    fill: '#6819B8',
                    // Text size
                    fontSize: '26px',
                  },
                }}
              />
            </div>
            <div className="is-flex align-items-center justify-content-between mt-15px">
              <p className="m-profile-course-level">LEVEL: {userLevelToString(course.level)}</p>
              <p className="m-profile-course-progress">
                {course.webinarsPassed}/{course.webinarsCount}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ProfileCoursesMobile.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.number.isRequired,
      level: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      webinarsCount: PropTypes.number.isRequired,
      webinarsPassed: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default ProfileCoursesMobile;
